import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { ArrowLeft, MapPin, Wallet, Truck } from "lucide-react";
import { api, inr } from "../../lib/api";

export default function RiderHistory() {
    const [rows, setRows] = useState([]);
    useEffect(() => { api.get("/rider/orders/mine?include_history=true").then(({ data }) => setRows((data || []).filter(o => ["DELIVERED", "CANCELLED"].includes(o.status)))); }, []);
    return (
        <div className="bizil-rider max-w-md mx-auto pb-20">
            <header className="px-4 py-4 flex items-center gap-3 bg-card border-b border-border sticky top-0 z-10">
                <Link to="/rider" className="p-1 -ml-1"><ArrowLeft size={22} /></Link>
                <p className="font-bold text-sm">Delivery history · {rows.length}</p>
            </header>
            <div className="p-4 space-y-2">
                {rows.length === 0 && <p className="text-sm text-muted-foreground text-center py-10">No completed deliveries yet.</p>}
                {rows.map((o) => (
                    <Link key={o.id} to={`/rider/orders/${o.id}`} className="block bg-card border border-border rounded-2xl p-3">
                        <div className="flex items-center gap-2 text-[10px] flex-wrap">
                            <span className="font-bold text-xs">{o.order_unique_id}</span>
                            <Badge>{o.status}</Badge>
                            {o.zone_name && <Badge tone="sky"><MapPin size={9} className="inline mr-0.5" />{o.zone_name}</Badge>}
                        </div>
                        <p className="text-xs mt-1">{o.restaurant_name} → {[o.delivery_address?.line1, o.delivery_address?.city].filter(Boolean).join(", ")}</p>
                        <p className="text-xs text-muted-foreground mt-1 inline-flex items-center gap-1">
                            {o.cdc_enabled ? <><Truck size={11} /> CDC</> : o.payment_method === "COD" ? <><Wallet size={11} /> COD</> : "Prepaid"} · {inr(o.totals?.grand_total)}
                        </p>
                    </Link>
                ))}
            </div>
        </div>
    );
}

function Badge({ children, tone }) {
    const tones = { sky: "bg-sky-100 text-sky-700" };
    const cls = tone ? tones[tone] : "bg-emerald-100 text-emerald-700";
    return <span className={`text-[10px] uppercase tracking-wider font-bold px-1.5 py-0.5 rounded-full ${cls}`}>{children}</span>;
}
